import { Component, Inject, Optional, OnDestroy } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { cleanUpAllTourStates } from 'src/app/libs/helpers/tours';

@Component({
  selector: 'app-modal-end-tour',
  standalone: false,
  templateUrl: './modal-end-tour.component.html',
})
export class ModalEndTourComponent implements OnDestroy {
  serviceName: string = 'API Shipping Delivery';

  constructor(
    private modalRef: NzModalRef,
    @Optional() @Inject(NZ_MODAL_DATA) public nzModalData: any
  ) {
    if (nzModalData && nzModalData.serviceName) {
      this.serviceName = nzModalData.serviceName;
    }
  }

  handleFinish(): void {
    cleanUpAllTourStates();
    this.modalRef.destroy();
  }

  ngOnDestroy(): void {
    cleanUpAllTourStates();
  }
}
